// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete } from "./operations.js";
export { RegisteredIdentitiesDeleteOptionalParams } from "./options.js";
